export default __webpack_public_path__ + "static/media/level-up-3.99639089.mp3";